export default "__VITE_PUBLIC_ASSET__9c5cdc89__"